// F1/R8 — **WHAT THIS HOUSE SAYS WHEN SOMETHING OF HERS IS SAVED, AND WHEN IT IS NOT.**
//
// Moved out of App.tsx at its declaration when the funnel arm pushed that file over the R8 ceiling
// (roadmap 7 ratchets it down, never up). It is read at TWENTY call sites, so it was already the
// shared answer — it just lived where no gate could reach it.
//
// **WHY IT IS ITS OWN MODULE AND NOT SOMEWHERE THAT ALREADY EXISTS, MEASURED RATHER THAN GUESSED:**
//   • `src/lib/labels.ts` is where the display copy lives, and its entry requirement is that every
//     module there imports NOTHING but `import type` — which is the property that lets a `.mjs` gate
//     load and RUN eighteen thousand lines of law. This composes from `t`, so putting it there would
//     have broken that reach for a tidier-looking file (R5/R6/R8's own rule, refused).
//   • `src/strings.js` is the CATALOG. A row read only by the catalog it lives in is a row no
//     surface reads, and ITEM 14b's census says so out loud — it went RED on `save.failed` when this
//     function was parked there, correctly, because *reachable from the catalog* and *read by a
//     surface* are two different facts (R18).
// So it follows the shape `magicRoom.js`, `pushSettings.js` and `headerIcons.js` already have: a
// small shared `.js` law, named in that census's own roster with its reason.
//
// **THREE SENTENCES, BECAUSE THERE ARE THREE OUTCOMES (R18/R39/R47):** it saved, she is not signed
// in, and it refused. Every save route in this house **refuses with HTTP 200 and `{ ok: false }`**,
// so a caller reading a status code calls a refusal a success — which is exactly why *saved* and
// *failed* are two sentences a surface chooses between rather than one hopeful one. `failed` is
// overridable because a route that explains ITSELF says more than a generic apology.
import { t } from "./strings.js";

export const saveCopy = (language, failed) => ({
  done: t(language, "save.done"),
  signIn: t(language, "save.signIn"),
  failed: failed ?? t(language, "save.failed"),
});
